import type { FC } from 'react'

import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import IconWrapper from '@segment/matcha/components/IconWrapper'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import {
  EngagingIcon,
  CertificateIcon,
  CustomerSuccessIcon,
  BusinessIcon,
} from '@segment/matcha/components/Icons/Brandbook'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const FeatureBoxes: FC = () => {
  const theme = useTheme()

  const boxes = [
    {
      title: `Instructor-led Training`,
      text: `Expert-led, hands-on enablement designed to accelerate and upskill knowledge in Segment solutions.`,
      icon: <CertificateIcon color={theme.palette.neutrals.black[100]} />,
    },
    {
      title: `Advisory Services`,
      text: `Strategic assessment and architectural guidance of your data flows, customer data pipelines, designs, and recommendations make them cleaner, faster, streamlined, and more resilient.`,
      icon: <BusinessIcon color={theme.palette.neutrals.black[100]} />,
    },
    {
      title: `Jumpstart`,
      text: `Strategic planning & implementation guidance activates business-critical audiences in your downstream tools. Our team sends best-in-class, succinct & powerful data from your Sources to Destinations.`,
      icon: <EngagingIcon color={theme.palette.neutrals.black[100]} />,
    },
    {
      title: `Resident Architects`,
      text: `Dedicated, ongoing strategic planning, architectural guidance & enablement support paced annually and customized to your specific needs.`,
      icon: <CustomerSuccessIcon color={theme.palette.neutrals.black[100]} />,
    },
  ]
  return (
    <>
      <SytledSectionBase variant="noCopy">
        <Section.Contents>
          <ColumnTrack columns={1} overrides={{ md: 4 }}>
            {boxes.map(({ title, text, icon }, index) => (
              <FeatureBoxBase key={index} headerPosition="top" alignment="left">
                <FeatureBox.Header>
                  <IconWrapper background="white" elevation={1} variant="circle">
                    {icon}
                  </IconWrapper>
                </FeatureBox.Header>
                <FeatureBox.Body>
                  <FeatureBox.Title>{title}</FeatureBox.Title>
                  <FeatureBox.Text>{text}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </Section.Contents>
      </SytledSectionBase>
    </>
  )
}

const SytledSectionBase = styled(SectionBase)`
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    ${Section.Wrapper} {
      padding-top: 0;
    }
  }
`

export default FeatureBoxes
